import { get, post } from '@ug/utils';

export const dayuLogin = async (data = {}) => await post('/mapi/login/dayu-login', data);
export const getModuleAuths = async (data = {}) => await get('/mapi/common/auths/get-common-auths', data);
